import moment from 'moment';

export const formatedDate = (date) => {
  const data = moment(date)
  return data.format('HH:mm a | MMMM Do')
}